import ConsoleLog, { ConsoleLogGroup } from '@/utils/logs/console-log';

import elasticInstance from './elastic-log';

export const logger = ConsoleLog.getInstance({
  service: 'BO',
  group: (process.env.NEXT_PUBLIC_CONSOLE_LOG_GROUP as ConsoleLogGroup) || 'DEBUG',
  hideValues: process.env.NEXT_PUBLIC_LOG_HIDE_VALUE === 'true',
});

export const elasticLogger = elasticInstance;
